import React, { createContext, useState, useContext, useEffect } from 'react';

// สร้าง Context
const LoginContext = createContext();

// สร้าง Provider
export const LoginProvider = ({ children }) => {


    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        // ตรวจสอบว่า sessionStorage มีค่าหรือไม่
        return sessionStorage.getItem('isLoggedIn') === 'true';
    });

    const [user, setUser] = useState(() => {
        const storedUser = sessionStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });
    const [pwd, setPwd] = useState(() => {
        const storedPwd = sessionStorage.getItem('pwd');
        return storedPwd ? JSON.parse(storedPwd) : null;
    });

    const [passCode, setPassCode] = useState(() => {
        const storedPassCode = sessionStorage.getItem('passCode');
        return storedPassCode ? JSON.parse(storedPassCode) : null;
    });

    const login = ( userId,  userPwd , userpassCode ) => {
        setIsLoggedIn(true);
        setUser(userId);
        setPwd(userPwd);
        setPassCode(userpassCode);
        sessionStorage.setItem('isLoggedIn', 'true'); // บันทึกสถานะการล็อกอิน
        sessionStorage.setItem('user', JSON.stringify(userId)); // บันทึกข้อมูลผู้ใช้
        sessionStorage.setItem('pwd', JSON.stringify(userPwd)); // บันทึกรหัสผ่าน
        sessionStorage.setItem('passCode',JSON.stringify(userpassCode));
    };

    const logout = () => {
        setIsLoggedIn(false);
        setUser(null);
        setPwd(null);
        setPassCode(null);
        sessionStorage.removeItem('isLoggedIn'); 
        sessionStorage.removeItem('user'); 
        sessionStorage.removeItem('pwd'); 
        sessionStorage.removeItem('passCode');
    };

    return (
        <LoginContext.Provider value={{ isLoggedIn, user, pwd , passCode, login, logout }}>
            {children}
        </LoginContext.Provider>
    );
};

// ฟังก์ชันสำหรับใช้งาน Context ใน Component อื่นๆ
export const useLogin = () => {
    return useContext(LoginContext);
};
